<template>
  <nav>
    <ul class="navigation_desktop">
      <li class="detalhe_esquerda"></li>
      <li class="detalhe_direita"></li>
      <div class="items_navigation_wrapper">
        <li
          class="navigation_step"
          v-for="n in stepsQuantity"
          :key="n"
          :class="{ activeStep: n == stepAtual }"
        >
          <span>PASSO {{ n }}</span>
        </li>
      </div>
      <!--items_navigation_wrapper-->
    </ul>
    <ul class="navigation_mobile">
      <li
        v-for="n in stepsQuantity"
        :key="n"
        :class="{ activeStep: n == stepAtual }"
      >
        <span>{{ n }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Navigation",
  data() {
    return {};
  },
  computed: {
    ...mapState(["stepAtual", "stepsQuantity"]),
  },
};
</script>

<style scoped>
.navigation_mobile {
  display: none;
  padding-left: 0;
}

.items_navigation_wrapper {
  width: 100%;
  padding-left: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-evenly;
  list-style-type: none;
  height: 100%;
  margin: 0;
  flex-wrap: nowrap;
  position: relative;
  top: 17px;
}

nav {
  display: block;
  height: auto;
  position: absolute;
  width: 768px;
  top: 150px;
  left: 0px;
  background-image: url("../assets/images/detalhe_meio.png");
  height: 86px;
}

nav ul {
  position: relative;
}

nav ul li {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #7e150e;
}

nav ul li span {
  margin-top: 5px;
}

nav ul li.activeStep {
  color: white;
}

.detalhe_direita {
  position: absolute;
  right: -120px;
  background-image: url("../assets/images/detalhe_direita.png");
  width: 120px;
  height: 86px;
  top: 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.detalhe_esquerda {
  position: absolute;
  left: -120px;
  background-image: url("../assets/images/detalhe_esquerda.png");
  width: 120px;
  height: 86px;
  top: 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.navigation_step {
  border-right: 2px solid #7e150e;
}

.navigation_step:last-of-type {
  border-right: none;
}

ul.navigation_desktop {
  padding: 0;
}

@media screen and (max-width: 1050px) {
  .navigation_mobile {
    display: flex;
    position: relative;
    top: 12px;
  }

  .navigation_desktop {
    display: none;
  }

  nav {
    position: static;
    width: 100%;
    display: flex;
    background: #e31837;
    flex-direction: row;
    align-items: center;
    display: block;
    height: auto;
    width: 100%;
    max-width: 588px !important;
    margin: 0 auto;
    border-radius: 45px;
    display: flex;
    align-items: center;
  }

  nav ul {
    width: 100%;
    position: relative;
    top: 7px;
  }

  nav ul li span {
    margin-top: 0px;
  }
}

@media screen and (max-width: 680px) {
  nav {
    position: static;
    width: 100%;
  }
  nav ul {
    max-width: 640px;
  }
}

.mobile_nav_circle {
  display: block;
  width: 24px;
  height: 24px;
  border: 1px solid #fff;
  position: relative;
  border-radius: 100%;
  margin-top: 0px;
}

.mobile_nav_circle > span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  margin-top: 2px;
}
</style>
